import React, { ReactNode } from "react";

import SiteFooter from "../organisms/SiteFooter";
import SiteHeader from "../organisms/SiteHeader";
import { ThemeProvider, useTheme } from "../molecules/ThemeToggle";

function MarketingShell({ children }: { children: ReactNode }) {
  const { isDark } = useTheme();
  return (
    <div className={isDark ? "dark" : ""}>
      <div className="bg-dotted flex min-h-screen flex-col text-gray-900 dark:text-gray-100">
        <SiteHeader />
        <main className="flex-1">{children}</main>
        <SiteFooter />
      </div>
    </div>
  );
}

interface MarketingLayoutProps {
  children: ReactNode;
}

export default function MarketingLayout({ children }: MarketingLayoutProps) {
  return (
    <ThemeProvider>
      <MarketingShell>{children}</MarketingShell>
    </ThemeProvider>
  );
}
